import { TextConfigurationItem, TextConfigurationItemTranslation } from '../types-store';

export const getTranslationForLanguage = (
  message: TextConfigurationItem,
  languageId: number
): TextConfigurationItemTranslation =>
  message && message.translations && message.translations
    .find(
      t => t.language === languageId
    ) || {
    language: languageId,
    text: undefined,
    originalText: undefined
  };
